/**
 * File navigation.js.
 *
 */

jQuery(document).ready(function ($) {
    $('.menu-toggle')
        .on('click', function () {
        if ($(this).attr('aria-expanded') == 'false') {
            $(this).attr('aria-expanded', 'true');
            $('.mobile-menu').animate({'marginLeft': '0'}, 500);
        } else {
            $(this).attr('aria-expanded', 'false');
        }
    })
        .hover(function () {
                $('i', this).addClass('fa-rotate-90');
            },
            function () {
                $('i', this).removeClass('fa-rotate-90');
            }
        )

    $('.close-menu')
        .on('click', function (e) {
            e.preventDefault();
            $('.mobile-menu').animate({'marginLeft': '-100%'}, 500);
            $('.menu-toggle').attr('aria-expanded', 'false');
        })
        .hover(function () {
                $(this).addClass('fa-rotate-90');
            },
            function () {
                $(this).removeClass('fa-rotate-90');
            }
        )

});

const el = document.querySelector(".site-header-wrapper")
const observer = new IntersectionObserver(
  ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
  { threshold: [1] }
);

if (el){
    observer.observe(el);
}
